import { baseClient } from './baseRequest';

export enum CalendarEventsType {
  NATIONAL_HOLIDAY = 'National holiday',
}
export type DateTime = {
  day: number;
  month: number;
  year: number;
};

export type State = {
  name: string;
  abbrev: string;
  iso: string;
};

export type GeographicRegion = {
  name: string;
  code: string;
};
export type CalendarEvent = {
  id: string;
  name: string;
  description: string;
  date: DateTime;
  country: GeographicRegion;
  state?: State[];
  primaryType: string;
  type: string[];
  emojis?: string[];
};

export type CalendarEventApiClient = {
  getCalendarEvent: (id: string) => Promise<CalendarEvent>;
  getCalendarEvents: (
    country: string,
    year: number,
    state?: string,
  ) => Promise<CalendarEvent[]>;
};

const calendarEventApiClient: CalendarEventApiClient = {
  getCalendarEvent: async (id: string) => {
    return baseClient.get<CalendarEvent>({
      url: `/studio/calendar-events/${encodeURIComponent(id)}`,
    });
  },
  getCalendarEvents: async (country: string, year: number, state?: string) => {
    const params = new URLSearchParams({ country, year: year.toString() });
    if (state) {
      params.append('state', state);
    }
    const url = `/studio/calendar-events/?${params.toString()}`;
    return baseClient.get<CalendarEvent[]>({
      url,
    });
  },
};

export default calendarEventApiClient;
